module.exports = __webpack_public_path__ + "img/SAM_0042.fcd00e17.jpg";